import { TypedApi } from "@tento-core/typed-api";
import { Network as JsNet } from "@tento-lona/network";
import { SheetsNetwork as RowsNet } from "@tento-lona/sheets";
import { Network as AppNet } from "./@generated/network";

// Routes from all three codegen namespaces. so_lona's web UI calls
// routes spread across:
//   - JsNet  : /user/* (auth, subscription, themes, connections, …)
//   - RowsNet: /rows/*, /sheets/*, /calendars, /tasks
//   - AppNet : /debug/*, /public/*, /mock/*, /build/*, /tracing/*, /sync/{k}/status
type Routes = JsNet.Routes & RowsNet.Routes & AppNet.Routes;

const REVIVERS = {
  ...(JsNet.REVIVERS as Record<string, unknown>),
  ...(RowsNet.REVIVERS as Record<string, unknown>),
  ...(AppNet.REVIVERS as Record<string, unknown>),
} as Parameters<typeof TypedApi.makeWith<Routes>>[0];

export const LonaApi = TypedApi.makeWith<Routes>(REVIVERS);
